module.exports = __webpack_public_path__ + "static/media/SF_nn_sekundaerlogo_postale_oslo_viken_pos.4811e070.pdf";